import React from 'react';
import Nav from './Nav';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import './salesquote.css';
import { Box, Typography, IconButton } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Infor = () => {
  return (
    <div className="Home">
      <Nav />
      <div className="dash-main">
        <div className="squote">
          {/* Header Section */}
          <Box
            display="flex"
            alignItems="center"
            sx={{ padding: "8px 16px", backgroundColor: "#f5f5f5", height: "48px" }}
          >
            <IconButton component={Link} to="/">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <Typography variant="h6" sx={{ marginLeft: "8px", fontSize: "1rem" }}>
              Information
            </Typography>
          </Box>

          {/* Accordion Section */}
          <div style={{ paddingTop: "8px" }}>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="new-drugs-content"
                id="new-drugs-header"
              >
                <Typography component="span">New Drugs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <strong>Overview:</strong> Our inventory has been updated with the latest FDA-approved drugs that address emerging health challenges. These include breakthroughs in treating chronic diseases, rare conditions, and advanced therapies.
                  <br /><br />
                  <strong>Highlighted Additions:</strong>
                  <ul>
                    <li><strong>Drug A:</strong> A revolutionary treatment for autoimmune diseases that reduces symptoms within weeks.</li>
                    <li><strong>Drug B:</strong> A newly launched antibiotic that combats drug-resistant bacteria effectively.</li>
                    <li><strong>Drug C:</strong> The latest anti-cancer medication designed to target specific tumor types.</li>
                  </ul>
                  These drugs are now available for immediate distribution to healthcare providers.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="new-devices-content"
                id="new-devices-header"
              >
                <Typography component="span">New Devices</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <strong>Overview:</strong> Discover the cutting-edge medical devices recently added to our catalog. These devices are designed to improve patient outcomes and streamline medical procedures.
                  <br /><br />
                  <strong>Top Devices:</strong>
                  <ul>
                    <li><strong>Portable Ultrasound Machine:</strong> A compact and highly portable device for diagnostic imaging in remote locations.</li>
                    <li><strong>Automated Blood Analyzer:</strong> Delivers rapid and accurate results, enhancing laboratory efficiency.</li>
                    <li><strong>Wearable Health Monitors:</strong> Devices that provide real-time tracking of vital signs, enabling remote patient care.</li>
                  </ul>
                  Contact us to learn more about device specifications and training options.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="training-content"
                id="training-header"
              >
                <Typography component="span">Training Opportunities</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <strong>Overview:</strong> We believe in empowering healthcare professionals through continuous education and training on the latest medical practices and technologies.
                  <br /><br />
                  <strong>Upcoming Sessions:</strong>
                  <ul>
                    <li><strong>Drug Administration Workshop:</strong> Learn about the safe and effective use of newly launched medications.</li>
                    <li><strong>Device Training Program:</strong> Hands-on training sessions on operating and maintaining advanced medical devices.</li>
                    <li><strong>Healthcare Leadership Seminar:</strong> Enhance your leadership skills to manage healthcare teams effectively.</li>
                  </ul>
                  Join us in advancing healthcare delivery through knowledge and expertise. For registration, click the button below.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Infor;
